<script>
  import CabecalhoEdital from './CabecalhoEdital.vue';
  import Paginacao from '~componentes/Paginacao.vue';
  import Carregando from '~componentes/Carregando.vue';
  import editalServico from '../../servico';
  import { datepicker } from 'vue-strap';

  export default {
    components: { CabecalhoEdital, Paginacao, Carregando, datepicker },
    data() {
      return {
        editais: [],
        publicacoes: [],
        carregando: false,
        tituloEdital: '',
        numeroEdital: '',
        anoEdital: '',
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        tituloProjeto: '',
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      listaEditais(pagina = 1) {
        this.carregando = true;
        return editalServico
          .editais(pagina, this.tituloEdital, this.numeroEdital, this.anoEdital)
          .then(resultado => {
            this.editais = resultado.registros;
            this.totalRegistros = resultado.totalRegistros;
            this.totalPaginas = resultado.totalPaginas;
            this.registrosPorPagina = resultado.registrosPorPagina;
            this.carregando = false;
          });
      },
      listaPublicacoesRecentes() {
        this.carregando = true;
        return editalServico
          .publicacoes()
          .then(resultado => {
            this.publicacoes = resultado;
            this.carregando = false;
          });
      },
      limparFiltros(callback) {
        this.$set(this, 'tituloEdital', '');
        this.$set(this, 'numeroEdital', '');
        this.$set(this, 'anoEdital', '');
        
        if (callback) return callback();
      },
      detalhar(id) {
        const filtrosAtivos = {};

        if (this.tituloEdital) filtrosAtivos.tituloEdital = this.tituloEdital;
        if (this.numeroEdital) filtrosAtivos.numeroEdital = this.numeroEdital;
        if (this.anoEdital) filtrosAtivos.anoEdital = this.anoEdital;

        this.$router.push({
          name: 'editais.detalhar',
          params: { id },
          query: filtrosAtivos
        });
      },
      padronizarTituloEdital(id) {
        let tituloPadronizado = '';
        const edital = this.editais.find(( e ) => e.idEdital === id);

        tituloPadronizado = `Edital ${edital.numeroEdital}/${edital.anoEdital} - ${edital.tituloEdital}`;

        return tituloPadronizado;
      },
      padronizarTituloPublicacao(id) {
        let tituloPadronizado = '';
        const publicacao = this.publicacoes.find((p) => p.idEdital === id);

        tituloPadronizado = `Edital ${publicacao.numeroEdital}/${publicacao.anoEdital} - ${publicacao.tituloEdital}`;

        return tituloPadronizado;
      },
      restoreFilters() {
        if (Object.keys(this.$route.query).length) {
          this.tituloEdital = this.$route.query.tituloEdital || '';
          this.numeroEdital = this.$route.query.numeroEdital || '';
          this.anoEdital = this.$route.query.anoEdital || '';
        }
      }
    },
    watch: {

    },
    computed: {

    },
    async mounted() {
      this.$root.tituloDaPagina = 'Editais';
      this.restoreFilters();
      this.listaPublicacoesRecentes();
      this.listaEditais();
    },
  }
</script>

<template>
  <div>
    
    <div class="row">
      <div class="col-xs-12">

        <div class="ibox float-e-margins">

          <div class="table-responsive" style="word-wrap: break-word; padding-top: 6px;">
            <table class="table tabela-custom-gradiente">
              <thead>
                <tr>
                  <th colspan="3" class="text-center">Publicações recentes</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="publicacao in publicacoes" :key="publicacao.idPublicacaoEdital">
                  <td>
                    <i class="fa fa-bell-o"></i>
                    <span class="clicavel" @click="detalhar(publicacao.idEdital)">{{ padronizarTituloPublicacao(publicacao.idEdital) }}</span></td>
                  <td><span>{{ publicacao.nomeTipoPublicacaoEdital }}</span></td>
                  <td class="text-right"><span>{{ publicacao.dataHoraCriacaoPublicacaoFormatada }}</span></td>
                </tr>
                <tr v-show="carregando">
                  <td colspan="3">
                    <i class='fa fa-spinner fa-pulse'></i> Carregando...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="ibox-title">
            <h5>Filtrar editais</h5>
          </div>

          <div class="ibox-content">

            <div class="hidden-print">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">Título (Nome Projeto, Nº Edital, Ano)</label>

                    <input type="text" class="form-control" id="titulo-edital" v-model="tituloEdital">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="control-label">Número</label>

                    <input type="text" class="form-control" id="numero-edital" v-model="numeroEdital">
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="control-label">Ano</label>

                    <input type="text" class="form-control" id="ano-edital" v-model="anoEdital">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-8">

                  <button class="btn btn-primary" type="button" @click="listaEditais()">
                    <i class="fa fa-search"></i> Filtrar
                  </button>

                  <button class="btn btn-default" type="button" @click="limparFiltros(listaEditais)">
                    <i class="fa"></i> Limpar filtros
                  </button>

                </div>
              </div>
            </div>

            <div class="padding-5"></div>

            <cabecalho-edital titulo="Relatório de editais" borda=""></cabecalho-edital>

            <div class="table-responsive">
              <table class="table table-bordered table-hover table-striped pointer relatorio">
                <thead>
                  <tr>
                    <th>Título</th>
                    <th>Número</th>
                    <th>Ano</th>
                    <th>Data de postagem</th>
                    <th>Data da última atualização</th>
                    <th class="action"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="edital in editais" :key="edital.idEdital">
                    <td @click="detalhar(edital.idEdital)">{{ padronizarTituloEdital(edital.idEdital) }}</td>
                    <td @click="detalhar(edital.idEdital)">{{ edital.numeroEdital }}</td>
                    <td @click="detalhar(edital.idEdital)">{{ edital.anoEdital }}</td>
                    <td @click="detalhar(edital.idEdital)">{{ edital.dataHoraCadastroFormatada }}</td>
                    <td @click="detalhar(edital.idEdital)">{{ edital.dataHoraCriacaoPublicacaoFormatada }}</td>
                    <td>
                      <button class="btn btn-primary btn-xs" @click="detalhar(edital.idEdital)">
                        <i class="fa fa-file-text-o"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="8">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="listaEditais"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>

          </div>
        </div>

      </div>
    </div>
    
  </div>
</template>

<style>
/* Customização da Tabela */
.tabela-custom-gradiente {
  background: linear-gradient(135deg, #2c3e50, #39838f) !important;
  color: white !important;
  border: none !important;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
  padding: 20px 25px !important;
}

/* Remove as bordas de todas as células */
.tabela-custom-gradiente th,
.tabela-custom-gradiente td {
  border: none !important;
  padding: 12px 15px;
}

/* Cabeçalho */
.tabela-custom-gradiente thead tr:first-child th {
  font-size: 1.1em;
  letter-spacing: 1px;
}

/* Carregamento  */
.tabela-custom-gradiente .fa-spinner {
  color: white;
}

.clicavel {
  cursor: pointer;
}

.clicavel:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/edital/componentes/compartilhado/ListaEditais.vue